// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import { COLORS, TYPOGRAPHY } from '@app/constants';
import { Controller, Control } from 'react-hook-form';
import { ArrowDown } from '@app/ui/iconComponents';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import Checkbox from '../../../Checkbox';
import { BreakpointsEnum, FilterInputType, IFilter } from '@app/types';
import Radio from '@app/ui/components/Radio';
import Switch from '@app/ui/components/Switch';
import dynamic from 'next/dynamic';
import SliderInput from '@app/ui/components/SliderInput';
import { filterTooltips } from '@app/pageComponents/AllTherapistsPage/constants';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { actions, selectors } from '@app/store';
import { useHasMounted } from '@app/hooks/useHasMounted';
import NumberFromRangeSelector from '../../../NumberFromRangeSelector';
import TherapistAgeSelector from '../../../TherapistAgeSelector';

const Tooltip = dynamic(import('../../../../components/Tooltip'));

type Props = IFilter & {
  isReset?: boolean;
  control: Control;
  childAge?: number;
  setChildAge?: Dispatch<SetStateAction<number>>;
  therapistAge?: string | undefined;
  setTherapistAge?: Dispatch<SetStateAction<string | undefined>>;
};

const Dropdown: FC<Props> = ({
  icon,
  name,
  title,
  control,
  checked = [],
  isReset = false,
  canExpand = true,
  tooltip,
  childAge,
  setChildAge,
  therapistAge,
  setTherapistAge,
  ...props
}) => {
  const hasMounted = useHasMounted();

  const selectedFiltersValues = useAppSelector(
    selectors.allTherapistsFilters.selectSelectedFiltersValues,
  );

  const dispatch = useAppDispatch();

  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [checkedValues, setCheckedValues] = useState<(string | number)[]>([]);

  const [hasChecked, setHasChecked] = useState<boolean>();

  useEffect(() => {
    const previousValue: string | string[] | undefined =
      selectedFiltersValues?.[name];
    setCheckedValues((Array.isArray(previousValue) ? previousValue : [previousValue]) || []);
    setHasChecked(!!selectedFiltersValues?.[name]?.length);
  }, [selectedFiltersValues?.[name]]);

  useEffect(() => {
    ////DEBUG: console.log(`uEf dropdown ${ name } options`, props.options )
    if (isReset) setCheckedValues([]);
  }, [isReset]);

  const handleSelect = (
    value: string | number | boolean,
    isMultiSelect = true,
  ) => {
    console.log(`handleSelect(${value})`);

    let updSelectedFiltersValues = value;
    let result = value;

    switch (props.inputType) {

      case FilterInputType.Radio:

      case FilterInputType.Switch:

        if (checkedValues.includes(value)) {
          updSelectedFiltersValues = undefined;
          result = undefined;
          setCheckedValues([]);
        } else {
          updSelectedFiltersValues = [value];
          result = updSelectedFiltersValues;
          setCheckedValues([value]);
        }

        break;

      case FilterInputType.Slider:

        updSelectedFiltersValues = [value];
        result = updSelectedFiltersValues;
        setCheckedValues([value]);

        break;

      default:

        if ( checkedValues ) { console.log('checkedValues', checkedValues);}
        if ( checkedValues?.includes(value) ) { console.log(`checkedValues?.includes(${value})`);}

        const filteredCheckedValues = checkedValues?.filter((name) => name !== undefined) || [];

        const newNames = filteredCheckedValues
          ?.includes(value)
          ? filteredCheckedValues?.filter((name) => name !== value)
          : isMultiSelect
          ? [...(filteredCheckedValues ?? []), value]
          : [value];

        updSelectedFiltersValues = newNames;
        result = newNames.length ? newNames : undefined;
        setCheckedValues(newNames);

        break;

    }

    console.log('handleSelect newSelectedValues:', {
      ...selectedFiltersValues,
      [ name ]: updSelectedFiltersValues
    }, checkedValues );

    dispatch(
      actions.allTherapistsFilters.setSelectedFiltersValues({
        selectedFiltersValues: {
          ...selectedFiltersValues,
          [name]: updSelectedFiltersValues,
        },
      }),
    );

    return result;
  };

  const titleWithIcon = (
    <>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      {title}
    </>
  );

  // const DEBUG_TYPE = item =>
  //   item?.url
  //     ? 'id: url'
  //     : item?.id
  //       ? 'id: id'
  //       : item?.name
  //         ? 'id: name'
  //         : 'item';

  const itemIdentificator = (item: any) =>
    item?.url || item?.id || item?.name || item;

  const getRequiredComponentByInputType = () => {
    switch (props.inputType) {
      case FilterInputType.Radio:
        return (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <List $isOpened={hasMounted && canExpand ? isOpened : true}>
                {props.options.map((item) => (
                  <ListItem key={itemIdentificator(item)}>
                    <StyledRadio
                      text={item?.name || item}
                      value={itemIdentificator(item)}
                      checked={
                        name === 'dayLimit' ?
                        selectedFiltersValues?.[name] == item?.id :
                        selectedFiltersValues?.[name]?.includes(item?.url || item?.id || item?.name || item)
                      }
                      onChange={() =>
                        field.onChange(
                          handleSelect(itemIdentificator(item), false),
                        )
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          />
        );

      case FilterInputType.Switch:
        return (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <StyledSwitch
                label={titleWithIcon}
                checked={selectedFiltersValues?.[name]?.[0]}
                onChange={() => {
                  field.onChange(
                    handleSelect(props.options[0]?.id || props.options[0]),
                  );
                }}
              />
            )}
          />
        );

      case FilterInputType.Slider:
        return (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <List $isOpened={hasMounted && canExpand ? isOpened : true}>
                <StyledSlider
                  step={50}
                  minBorder={props.options[0]}
                  maxBorder={props.options[1]}
                  value={
                    field?.value
                      ? field.value
                      : selectedFiltersValues?.[name]?.[0]
                      ? selectedFiltersValues?.[name]?.[0]
                      : props.defaultValue
                  }
                  onChangeValue={(value) => {
                    field.onChange(handleSelect(value, false));
                  }}
                  borderLabel="min"
                />
              </List>
            )}
          />
        );

      case FilterInputType.Range:
        return (
          <RangeWrapper $isOpened={hasMounted && canExpand ? isOpened : true}>
            <NumberFromRangeSelector value={childAge} set={setChildAge}/>
          </RangeWrapper>
        );

      case FilterInputType.RangeSecond:
        return (
          <RangeWrapper $isOpened={hasMounted && canExpand ? isOpened : true}>
            <TherapistAgeSelector value={therapistAge} set={setTherapistAge}/>
          </RangeWrapper>
        );

      default:
        return (
          <Controller
            name={name}
            control={control}
            render={({ field }) => {
              return (
                <List $isOpened={hasMounted && canExpand ? isOpened : true}>
                  {props.options.map((item) => {
                    // TODO: Перенести тултипы на бэк
                    const tooltip = filterTooltips.find(
                      (filterTooltip) => filterTooltip.name === item,
                    );

                    const listItem = (
                      <ListItem
                        key={item?.url || item?.id || item?.name || item}
                      >
                        <noscript>
                          <a
                            href={`https://pogovorim.online/all-therapists/${item?.url}/`}
                          >
                            {item?.name || item}
                          </a>
                        </noscript>

                        {hasMounted && (
                          <>
                            <StyledCheckbox
                              text={item?.name || item}
                              checked={selectedFiltersValues?.[name]?.includes(
                                item?.url || item?.id || item?.name || item,
                              )}
                              onChange={() =>
                                field.onChange(
                                  handleSelect(
                                    item?.url || item?.id || item?.name || item,
                                  ),
                                )
                              }
                              tip={item?.tip}
                            />
                          </>
                        )}
                      </ListItem>
                    );

                    if (tooltip) {
                      return (
                        <Tooltip label={tooltip.tooltip} placement="top">
                          {listItem}
                        </Tooltip>
                      );
                    }

                    return listItem;
                  })}
                </List>
              );
            }}
          />
        );
    }
  };

  const content = (
    <>
      {props.inputType !== FilterInputType.Switch && (
        <Head
          type={!canExpand ? undefined : 'button'}
          as={!canExpand ? 'span' : 'button'}
          onClick={canExpand ? () => setIsOpened(!isOpened) : undefined}
        >
          <Title $isGlowing={hasChecked}>
            {hasChecked ? (
              <>
                {titleWithIcon}

                {` (${
                  typeof checkedValues === 'object' ? checkedValues.length : 1
                })`}
              </>
            ) : (
              titleWithIcon
            )}
          </Title>

          {canExpand && (
            <StyledArrowDown
              $isOpened={hasMounted && canExpand ? isOpened : true}
              color={hasChecked ? COLORS.primary300 : COLORS.grayscale700}
            />
          )}
        </Head>
      )}

      <div>{getRequiredComponentByInputType()}</div>
    </>
  );

  return (
    <div>
      {tooltip ? (
        <Tooltip label={tooltip} placement="top">
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </div>
  );
};

export default Dropdown;

interface StyleProps {
  $isOpened?: boolean;
  $isGlowing?: boolean;
}

const Head = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  margin-bottom: 21px;
`;

const Title = styled.span<StyleProps>`
  ${TYPOGRAPHY.body1Medium14}
  color: ${({ $isGlowing }) =>
    $isGlowing ? COLORS.primary300 : COLORS.grayscale700};

  @media (max-width: ${BreakpointsEnum.sm}px) {
    ${TYPOGRAPHY.headline2Medium16}
  }
`;

const StyledArrowDown = styled(ArrowDown)<StyleProps>`
  transform: ${({ $isOpened }) => $isOpened && 'rotate(180deg)'};
  margin-left: 15px;
`;

const List = styled.ul<StyleProps>`
  display: ${({ $isOpened }) => !$isOpened && 'none'};
`;

const RangeWrapper = styled.div<StyleProps>`
  display: ${({ $isOpened }) => !$isOpened && 'none'};
`;

const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  display: flex;
  padding: 5px;
`;

const StyledCheckbox = styled(Checkbox)`
  ${TYPOGRAPHY.footnoteRegular13}
  color: ${COLORS.grayscale600};
  align-items: center;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    ${TYPOGRAPHY.body1Regular14}
  }
`;

const StyledRadio = styled(Radio)`
  ${TYPOGRAPHY.footnoteRegular13}
  color: ${COLORS.grayscale600};

  @media (max-width: ${BreakpointsEnum.sm}px) {
    ${TYPOGRAPHY.body1Regular14}
  }
`;

const StyledSwitch = styled(Switch)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    margin-top: 12px;
    margin-bottom: 6px;
  }

  & > span {
    ${TYPOGRAPHY.body1Medium14}
    color: ${COLORS.grayscale700};
    margin-right: 10px;

    @media (max-width: ${BreakpointsEnum.sm}px) {
      ${TYPOGRAPHY.headline2Medium16}
    }
  }
`;

const StyledSlider = styled(SliderInput)`
  input {
    padding: 5px 0 10px;
  }

  span {
    top: 5px;
  }
`;

const IconWrapper = styled.div`
  margin-right: 6px;
`;
